import { render, staticRenderFns } from "./NumberplateForm.vue?vue&type=template&id=5428c8ea&scoped=true"
import script from "./NumberplateForm.vue?vue&type=script&lang=ts"
export * from "./NumberplateForm.vue?vue&type=script&lang=ts"
import style0 from "./NumberplateForm.vue?vue&type=style&index=0&id=5428c8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5428c8ea",
  null
  
)

export default component.exports